// extracted by mini-css-extract-plugin
export default {"title":"FeaturesCards_title__7x4QL","description":"FeaturesCards_description__Zuzdu","card":"FeaturesCards_card__l6w-F","cardTitle":"FeaturesCards_cardTitle__ssVTb"};